<template>
  <div>

    <v-layout class="mt-2">
      <v-flex xs6>
        <BuscaSimplesApi
          style="width: 100%"
          label="Buscar"
          :disabled="acao != ''"
          route="gerencial/perfilanoletivo"
          :fieldSearch="buscarSelect"
          @found="encontrado"
          ref="buscaSimpleApi">
          <template slot-scope="propSlot">
            <span>{{ propSlot.item.anoletivo }} - {{ propSlot.item.descricaoperfilanoletivo }}</span>
          </template>
        </BuscaSimplesApi>
      </v-flex>
      <v-flex xs4 class="ml-3">
        <Select :options="buscaOptions" v-model="buscarSelect" label="" @change="selectBuscaChange"/>
      </v-flex>
    </v-layout>

    <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0" style="color: white;">
      <div v-if="$v.$invalid && $v.$dirty"> Preencha os campos corretamente.</div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>

    <FormBasico
      :submit="onSubmit"
      :acao="acao"
      :novo="novoPerfilAnoLetivo"
      :editar="editarPerfilAnoLetivo"
      :excluir="function() {}"
      :cancelar="cancelarPerfilAnoLetivo"
      :id="form.identificadorperfilanoletivo"
      class="mb-3">

      <v-tabs>
        <v-tabs-slider color="#fff"></v-tabs-slider>
        <v-tab @click="tabelaPerfilAnoLetivo">
          <v-icon left color="#757575">view_list</v-icon>
        </v-tab>
      </v-tabs>

      <v-card class="pa-3">
        <Input ref="id" type="text" label="Código do Perfil" disabled v-model="form.identificadorperfilanoletivo" />
        <Select ref="anoletivo" :options="anoLetivoOptions" v-model="form.anoletivo" label="Ano Letivo*" :disabled="acao != 'novo'" :v="$v.form.anoletivo"/>
        <TextArea rows="10" :disabled="acao == ''" v-model="form.descricaoperfilanoletivo" label="Descrição do Perfil" :v="$v.form.descricaoperfilanoletivo"/>
      </v-card>
    </FormBasico>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>

  </div>
</template>

<script>
import store from '@/store/index';
import api from '@/api';
import BuscaSimplesApi from '@/components/BuscaSimplesApi';
import { required, maxLength, minLength, between } from 'vuelidate/lib/validators';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';

const PerfilAnoLetivoRepository = RepositoryFactory.get('perfilAnoLetivo');

const setFormInicial = () => ({
  identificadorperfilanoletivo: '',
  anoletivo: '',
  descricaoperfilanoletivo: '',
});

export default {
  name: 'perfilanoletivo',
  components: { BuscaSimplesApi },

  data() {
    return {
      acao: '',
      form: setFormInicial(),
      msgError: '',
      msgArrayError: [],
      snackbar: false,
      submitText: '',
      formUltimo: {},
      buscarSelect: 'anoletivo',
      buscaOptions: [
        { value: 'anoletivo', text: 'Ano Letivo' },
        { value: 'identificadorperfilanoletivo', text: 'Código do Perfil' },
        { value: 'descricaoperfilanoletivo', text: 'Descrição do Perfil' },
      ],
      anoLetivoOptions: this.loadAnos(),
    };
  },

  validations() {
    return {
      form: {
        anoletivo: { required, between: between(2019, 9999) },
        descricaoperfilanoletivo: { required, minLength: minLength(20), maxLength: maxLength(4000) },
      },
      /*   GAMBIARRA
           A regra de validação abaixo foi inserida apenas para corrigir um pequeno erro na interface de usuário que ocorre quando o botão cancelar é usado.

           Quando a última regra de validação declarada não é válida, a validação impede que o botão cancelar seja executado.
           Porém, quando a última regra é válida, o erro não ocorre.
           Nesse caso, como nesta tela só há um campo sendo validado e ele não está válido quando o botão cancelar é clicado,
           é necessário lançar uma regra vazia abaixo somente para evitar de o erro ocorrer.
      */
      submitText: {},
    };
  },

  methods: {
    tabelaPerfilAnoLetivo(){
      this.$root.$router.push({
          name: 'tabelas',
          params: {
            titulo: 'Perfil do Ano Letivo / Listar',
            rota_api: 'gerencial/perfilanoletivo/tabela',
            headers: [{ text: 'Identificador', value: 'identificadorperfilanoletivo', filtable: true, sortable: false},
                      { text: 'Ano Letivo', value: 'anoletivo', filtable: true, sortable: false},
                      { text: 'Descrição do Perfil', value: 'descricaoperfilanoletivo', filtable: true, sortable: false},]
          }
      });
    },

    novoPerfilAnoLetivo() {
      this.acao = 'novo';
      this.form = setFormInicial();
      this.$v.$reset();
    },

    editarPerfilAnoLetivo() {
      if (this.form.identificadorperfilanoletivo !== '') {
        this.acao = 'editar';
      }
    },

    cancelarPerfilAnoLetivo() {
      if (this.acao === 'novo') {
        this.form = setFormInicial();
      }
      else {
        this.form = { ...this.formUltimo };
      }
      this.acao = '';
      this.msgArrayError = [];
      this.$v.$reset();
    },

    async onSubmit() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
        return;
      }

      try {
        let metodo;
        if ( this.acao == 'novo' ) metodo = 'postPerfilAnoLetivo';
        else if ( this.acao == 'editar') metodo = 'putPerfilAnoLetivo';

        const  {data}  = await PerfilAnoLetivoRepository[`${metodo}`]( this.form );

        this.acao = '';
        this.submitText = data.message;
        this.snackbar = true;
        this.msgArrayError = [];

        this.form = { ...data.results };
        this.formUltimo = { ...this.form };
      }
      catch (error) {
        if (error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      }
      this.$v.$reset();
      return true;
    },

    encontrado(dados) {
      this.form = setFormInicial();
      this.form = { ...dados, };
      this.formUltimo = { ...this.form };
      this.$refs.buscaSimpleApi.lista = [];
    },

    selectBuscaChange() {
      this.$refs.buscaSimpleApi.busca = '';
    },

    loadAnos() {
      if (!store.getters.getAnoInicioSistema || !store.getters.getAnoAtualServidor) { return []; }
      let retornoOptions = [{text: '', value: ''}];
      for (let i = store.getters.getAnoAtualServidor; i >= store.getters.getAnoInicioSistema; i--) {
        retornoOptions.push({ text: i, value: i });
      }
      return retornoOptions;
    },
  },
};
</script>

<style lang="scss" scoped>
/* /deep/ #btn-acoes-t button:nth-child(3) { display: none !important;} */
::v-deep #btn-acoes-t button:nth-child(3) { display: none !important;}
</style>
